import classNames from "classnames"
import { RenamableText } from "features/data-management/workspace/TODO-put-in-package/RenamableText"
import {
    selectIdRenaming,
    setIdRenaming,
} from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useEffect, useRef } from "react"

type InspectorPanelKeyValueRenamableProps = {
    id: string
    keyTitle: string
    previewValue?: string
    inputValue: string
    sanitizer?: (value: string) => string | null
    onConfirm: (input: string) => void
}

export const InspectorPanelKeyValueRenamable = ({
    id,
    keyTitle,
    previewValue,
    inputValue,
    sanitizer,
    onConfirm,
}: InspectorPanelKeyValueRenamableProps) => {
    const dispatch = useAppDispatch()
    const idRenaming = useAppSelector(selectIdRenaming())
    const inputRef = useRef<HTMLInputElement>(null)

    const isRenaming = idRenaming === `inspector-panel-${id}`

    /**
     * Auto-focus input field when idRenaming is changed to this input ID.
     */
    useEffect(() => {
        if (isRenaming) inputRef.current?.focus()
    }, [isRenaming])

    return (
        <div className="flex-none h-8 relative">
            {/* Key & RenamableText */}
            <div className="flex gap-3 items-center w-full mt-1.5">
                {/* Field Key */}
                <h5 className="text-gray-0 w-24 select-none flex-none">{keyTitle}</h5>

                {/* RenamableText */}
                <div className={classNames("ml-1 mt-px", { "w-28": isRenaming })}>
                    <RenamableText
                        ref={inputRef}
                        Tag="h5"
                        title={isRenaming || !previewValue ? inputValue : previewValue}
                        id={id}
                        className="text-gray-0 cursor-text"
                        isRenaming={isRenaming}
                        shouldHighlightOnHover={true}
                        sanitizer={sanitizer}
                        onClick={() => dispatch(setIdRenaming(`inspector-panel-${id}`))}
                        onCancelRenaming={() => dispatch(setIdRenaming(undefined))}
                        onConfirmRenaming={(_, name) => {
                            onConfirm(name)
                            dispatch(setIdRenaming(undefined))
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
